/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_PAGE_FACADE = '/payment';
const RESOURCE_ROOT_FACADE = '/checkout';

const getPaymentDetails = (wcEnv, jwtToken, orderId) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;
    const resourcePage = `${RESOURCE_PAGE_FACADE}/${orderId}`;

    return restClient.getFacade(env, resourcePage, jwtToken)
        .then((response) => {
            if (response && response.data) {
                return response.data;
            }

            return response;
        });
};

export default getPaymentDetails;
